import * as React from 'react';

import { IScrollingContext } from '../types';

/* istanbul ignore next */
export const defaultScrollingContext: IScrollingContext = {
  refBlocksState: {},
  active: null,
  viewed: [],
  setActive: () => null,
  setViewed: () => null,
  setRefBlocksState: () => null,
};

export const scrollingContext = React.createContext(defaultScrollingContext);

export const Provider = scrollingContext.Provider;
